import { atom } from "jotai";

export const modalImages = atom({
  isOpen: false,
  itemImages: null,
  clickedImages: "",
});
